<div class="pdf-page app-aul-013-24" id="georgia1324">
  <!-- <app-policy-header></app-policy-header> -->
  <br />
  <p class="font-large" style="text-align: center">
    <b>AMENDATORY ENDORSEMENT</b>
  </p>
  <p class="font-large" style="text-align: center"><b>GEORGIA CHANGES</b></p>
  <p class="font-large" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>
  <p class="font-medium">
    <b>
      This endorsement comprising of policyholder notices, coverage changes and
      endorsements attaches to and forms part of the policy numbered
      {{ this.policyDetails?.policyNo }}
    </b>
  </p>
  <br />
  <p class="font-medium" style="text-decoration: underline">
    <b><u>FREQUENTLY ASKED QUESTIONS ABOUT YOUR SURPLUS LINES POLICY</u></b>
  </p>
  <p class="font-medium">
    Your broker has placed the insurance you requested in the "surplus lines
    market" with one or more surplus lines insurers. By definition, such surplus
    lines insurers are not licensed in the state, but this does not mean that
    the transaction is not regulated.
  </p>
  <p class="font-medium">
    The surplus lines market is an insurance marketplace that is established for
    the purpose of insuring unique or hard to place risks. Some of the rules
    that apply to surplus lines insurance policies and surplus lines insurance
    companies differ from those that govern coverage obtained from insurance
    companies licensed in your state.
  </p>
  <p class="font-medium">
    In order for you to better understand the surplus lines market and the
    rights you have in a surplus lines transaction, the following material is
    provided.
  </p>
  <p class="font-medium">
    Please read this brochure carefully, and should you have any questions after
    reading the material, do not hesitate to ask your broker. If you wish
    further information, please contact the Regulatory Services Division, Room
    604 West Tower, 2 Martin Luther King, Jr. Drive, Atlanta, Georgia 30334 or
    (404) 656-2074 or toll free at (800) 656-2298 (request Regulatory Services
    Division).
  </p>
  <p class="font-medium">
    <b>WHAT IS A SURPLUS LINES POLICY? </b>- A surplus lines policy is a policy
    placed with an insurer that is not licensed (or 'admitted') in this state,
    but is nonetheless eligible to provide insurance on property or liability
    insurance protection to citizens of this state through specially licensed
    agents or brokers known as surplus lines brokers.
  </p>
  <p class="font-medium">
    <b>WHY AM I GETTING COVERAGE FROM A SURPLUS LINES INSURER? </b>- Your agent
    or broker may have been unable to obtain the coverage you requested from
    insurance companies licensed in this state, but was able to obtain coverage
    from an eligible surplus lines insurance company. The reason for your agent
    or broker's action is that the risk or property for which you sought
    coverage may be unique or have certain risk characteristics that caused
    licensed insurers to decline to write the policy. In circumstances where
    licensed insurers will not write the risk, your broker is authorized by
    state law or regulation to obtain the coverage from a "surplus lines"
    insurer.
  </p>
  <p class="font-medium">
    <b
      >SINCE THE SURPLUS LINES INSURER IS UNLICENSED, IS THE TRANSACTION
      UNREGULATED? </b
    >- Surplus lines transactions are regulated by state law that require that
    surplus lines policies be procured only by specially licensed brokers. These
    are called surplus lines brokers and they are authorized to transact
    business with certain unlicensed insurers that meet financial and other
    eligibility standards set by the state. These insurers are known as surplus
    lines insurers. Your agent may have worked with a licensed surplus lines
    broker in securing your policy. Alternatively, your agent may hold a surplus
    lines broker's license.
  </p>
  <p class="font-medium">
    <b
      >IS MY SURPLUS LINES POLICY COVERED BY THE STATE GUARANTY OR INSOLVENCY
      FUND? </b
    >- No. There is no guaranty fund for coverage for surplus lines policies.
    The guaranty fund, which provides payments in the event that your insurance
    company becomes insolvent, only covers policies of licensed insurers.
  </p>
  <p class="font-medium">
    <b>HOW IS THE RATE OR PRICE OF A SURPLUS LINES POLICY DETERMINED? </b>- The
    rate or premium charged for a surplus lines policy is determined by the
    surplus lines insurer. As unlicensed insurers, surplus lines insurers do not
    file their rates or premiums with the state for review or approval.
  </p>
  <p class="font-medium">
    <b
      >DOES THE GEORGIA DEPARTMENT OF INSURANCE REVIEW OR APPROVE THE TERMS AND
      CONDITIONS OF THIS POLICY? </b
    >- Pursuant to O.C.G.A. Section 33-5-21.1, policies of surplus lines
    insurers are not reviewed or approved by the Georgia Department of
    Insurance.
  </p>
  <p class="font-medium">
    <b>CAN MY POLICY BE RENEWED OR EXTENDED? </b>- Your surplus lines policy may
    or may not be renewed or extended when the policy expires. An extension of
    the policy coverage will be dependent upon the continued unavailability of
    the policy coverage from insurers licensed in this state and the willingness
    of the surplus lines insurer to continue to accept the risk. Since a surplus
    lines policy is generally not subject to the same notice requirements as a
    policy issued by a licensed insurer, notice of a premium increase for a new
    policy term or the company's intent not to extend the policy at the same
    terms and conditions might not be provided until close to the date the
    policy expires. Therefore, you should keep in contact with your agent or
    broker, particularly as the expiration of the policy term nears, to
    ascertain the status of the policy and to assure continuity of coverage.
  </p>
  <div>
    <div>
      <p class="font-medium">
        <b
          ><span style="text-decoration: underline"
            >SERVICE OF SUIT CLAUSE</span
          ></b
        >
      </p>
    </div>
    <div>
      <p class="font-medium">
        <u>FORTEGRA SPECIALTY INSURANCE COMPANY</u>
      </p>
    </div>
    <ol style="padding-left: 12px" type="I">
      <li>
        In any cause of action arising under this policy, or certificate, cover
        note, or other confirmation of this insurance issued by your surplus
        lines agent, we will, at your request, submit to the jurisdiction of a
        court of competent jurisdiction within the United States. Nothing herein
        constitutes or should be understood to constitute a waiver of our rights
        to commence an action in any court of competent jurisdiction in the
        United States to remove an action to a United States District Court or
        to seek a transfer of a case to another court as permitted by the laws
        of the United States or of any state in the United States. In any suit
        instituted against us upon this policy, we will abide by the final
        decision of such court or of any appellate court in the event of appeal.
      </li>
      <br />
      <li>
        All lawful process may be served in any action, suit or proceeding
        instituted by, or on behalf of, you or any beneficiary under this
        policy, against us arising out of this policy, upon:
        <br />
        <p>
          <b>Corporate Creations Network Inc.</b><br />
          <b>2985 Gordy Parkway, 1st Floor</b><br />
          <b>Marietta, GA 30066</b><br />
          <b>Cobb County</b><br />
          <b>Phone: (561) 694-8107</b><br />
        </p>
      </li>
      <br />
      <li>
        Pursuant to any law of any state, the District of Columbia or territory
        of the United States which makes provision therefore, we hereby
        designate the Superintendent, Commissioner or Director of Insurance or
        other applicable individual specified for that purpose in the applicable
        statute or regulation, or his successor or successors in office, as
        attorney or agent for receipt of lawful service of process as our true
        and lawful attorney upon whom may be served any lawful process in any
        action, suit or proceeding instituted by or on behalf of you or any
        beneficiary hereunder arising out of this policy of insurance, and we
        hereby designate the above-named as the person to whom the said
        individual, the surplus lines producer, or any applicable state surplus
        lines association or stamping office, is authorized to mail such process
        or a true copy thereof. The service of process as set forth above and
        below is cumulative to any other methods which may be provided by law
        for service of process upon us.
      </li>
    </ol>
    <p class="font-small">
      ALL OTHER TERMS, CONDITIONS, PROVISIONS AND EXCLUSIONS OF THIS POLICY
      REMAIN THE SAME.
    </p>
  </div>
</div>
